// extracted by mini-css-extract-plugin
export var modalFooter = "_qa-0";